module.exports = __webpack_public_path__ + "img/activity63.ff620eac.png";